import { User } from 'core/auth/types';
import { ActualCommissionSchema } from 'modules/commissions';
import { InvoiceSchema } from 'modules/invoicing';
import { z } from 'zod';

export enum EAttachmentType {
    INVOICE = 'INVOICE',
    DELIVERY_NOTE = 'DELIVERY_NOTE',
}

export type TAttachment = {
    attachment_id: number;
    name: string;
    fileName: string;
    mimeType: string;
    type: EAttachmentType;
    sent: boolean;
    tsAdded: bigint;
    deleted: boolean;
    user_id?: number;
    uploadedBy?: User;
    commission_id?: number;
    commission?: ActualCommissionSchema;
    invoice_id?: number;
    invoice?: InvoiceSchema;
    invoiceCustomerEmail?: string | null;
    invoiceLanguage?: string | null;
};

export const AttachmentSchema = () => z.object({
    attachment_id: z.number(),
    name: z.string(),
    fileName: z.string(),
    mimeType: z.string(),
    type: z.nativeEnum(EAttachmentType),
    sent: z.boolean(),
    tsAdded: z.bigint(),
    deleted: z.boolean(),
    user_id: z.number().optional(),
    commission_id: z.number().optional(),
    invoice_id: z.number().optional(),
    invoiceCustomerEmail: z.string().nullable().optional(),
    invoiceLanguage: z.string().nullable().optional(),
})